import React from "react";
import Container from "../../components/Container/Container";
import Overview from "../Overview/Overview";

export default function Dashboard() {
  return (
    <Container>
      <Overview />
    </Container>
  );
}
